/* src/app/dialogs/group-editor/group-editor.component.css */
.list-item {
  display: flex !important;
  align-items: center !important;
  width: 100% !important;
}
::ng-deep .list-item .mat-mdc-list-item-meta,
::ng-deep .list-item .mat-list-item-meta {
  display: flex !important;
  align-items: center !important;
  margin-left: auto !important;
  padding-left: 8px;
}
.delete-icon {
  color: black !important;
}
.list {
  width: 100% !important;
}
::ng-deep .mat-mdc-list mat-mdc-list-base mdc-list {
  width: 100% !important;
}
/*# sourceMappingURL=group-editor.component-L7I2OX4R.css.map */
